export function getCurrencyFromCartData(cartData) {
  return cartData?.data.currency?.toLowerCase() || 'usd';
}
